import { render, staticRenderFns } from "./list-dispatch.vue?vue&type=template&id=418b0b6a&scoped=true"
import script from "./list-dispatch.vue?vue&type=script&lang=js"
export * from "./list-dispatch.vue?vue&type=script&lang=js"
import style0 from "./list-dispatch.vue?vue&type=style&index=0&id=418b0b6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b0b6a",
  null
  
)

export default component.exports